export const SINGLECALLCARD_ATTACHMENTS = 'SingleCallcardAttachments';
